"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AppSwitcher_component_exports = {};
__export(AppSwitcher_component_exports, {
  AppSwitcher: () => AppSwitcher
});
module.exports = __toCommonJS(AppSwitcher_component_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));
var import_react2 = require("react");
var import_useBreakpoints = require("../../../utils/useBreakpoints/useBreakpoints.hook");
var import_Select = require("../Select/Select.component");
var import_AppSwitcherItem = require("./AppSwitcherItem/AppSwitcherItem.component");
var import_AppSwitcherError = require("./AppSwitcherError/AppSwitcherError.component");
var import_AppSwitcher = require("./AppSwitcher.helpers");
var _templateObject;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var AppSwitcher = function AppSwitcher2(_ref) {
  var items = _ref.items, failed = _ref.failed, defaultSelected = _ref.defaultSelected, _ref$onSelect = _ref.onSelect, onSelect = _ref$onSelect === void 0 ? function() {
    return null;
  } : _ref$onSelect, _ref$shouldUpdateDefa = _ref.shouldUpdateDefaultSelected, shouldUpdateDefaultSelected = _ref$shouldUpdateDefa === void 0 ? false : _ref$shouldUpdateDefa;
  var _useBreakpoints = (0, import_useBreakpoints.useBreakpoints)(), isXs = _useBreakpoints.isXs;
  var _useMemo = (0, import_react2.useMemo)(function() {
    return (0, import_AppSwitcher.getDefaultSelected)(items, defaultSelected);
  }, [items, defaultSelected]), defaultIndex = _useMemo.defaultIndex, defaultItemSelected = _useMemo.defaultItemSelected;
  var moreThanOneItem = (items === null || items === void 0 ? void 0 : items.length) > 1;
  var hasData = !!(defaultItemSelected !== null && defaultItemSelected !== void 0 && defaultItemSelected.id);
  return /* @__PURE__ */ import_react.default.createElement(_StyledDiv, {
    $_css: [{
      "zIndex": "10",
      "display": "flex",
      "flex": "1 1 0%",
      "paddingLeft": "1rem",
      "paddingRight": "1rem"
    }]
  }, failed ? /* @__PURE__ */ import_react.default.createElement(import_AppSwitcherError.AppSwitcherError, null) : hasData && moreThanOneItem ? /* @__PURE__ */ import_react.default.createElement(import_Select.Select, {
    defaultIndex,
    floatingMargin: {
      "marginTop": "1rem"
    },
    dropdownPosition: !isXs ? "bottom" : void 0,
    shouldUpdateDefaultSelected,
    removeBtnMargin: true,
    role: "flyoutMenu"
  }, items.map(function(item) {
    return /* @__PURE__ */ import_react.default.createElement(import_Select.Option, {
      key: item.id,
      label: item.ariaLabel,
      onClick: function onClick() {
        return onSelect(item);
      },
      customStyle: {
        "& * p": {
          "display": "block",
          "fontSize": "1rem"
        }
      },
      role: "flyoutMenu",
      url: item.redirectionUrl
    }, /* @__PURE__ */ import_react.default.createElement(import_AppSwitcherItem.AppSwitcherItem, {
      label: item.label,
      imageSrc: item.imageSrc,
      ariaLabel: item.ariaLabel
    }));
  })) : hasData ? /* @__PURE__ */ import_react.default.createElement(_StyledDiv2, null, /* @__PURE__ */ import_react.default.createElement(import_AppSwitcherItem.AppSwitcherItem, {
    label: defaultItemSelected === null || defaultItemSelected === void 0 ? void 0 : defaultItemSelected.label,
    imageSrc: defaultItemSelected === null || defaultItemSelected === void 0 ? void 0 : defaultItemSelected.imageSrc
  })) : null);
};
AppSwitcher.displayName = "AppSwitcher";
var _StyledDiv = (0, import_styled_components.default)("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function(p) {
  return p.$_css;
});
var _StyledDiv2 = (0, import_styled_components.default)("div").withConfig({
  displayName: "AppSwitchercomponent___StyledDiv2",
  componentId: "sc-10nnegj-0"
})({
  "fontFamily": "Circular Std",
  "fontWeight": "700",
  "@media (min-width: 680px)": {
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem"
  }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AppSwitcher
});
//# sourceMappingURL=AppSwitcher.component.js.map